import { render, staticRenderFns } from "./SchoolPropagandistModal.vue?vue&type=template&id=54925537&"
import script from "./SchoolPropagandistModal.vue?vue&type=script&lang=js&"
export * from "./SchoolPropagandistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports